export const FULL_DATE_FORMAT = "DD.MM.YYYY";
